import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { useAuth } from '../auth/AuthProvider.js';
const MINIMIZED_KEY = 'fm-tester-panel-minimized';
const TesterPanelContext = createContext(null);
export function useTesterPanel() {
    const value = useContext(TesterPanelContext);
    if (!value) {
        throw new Error('useTesterPanel must be used within TesterPanelProvider');
    }
    return value;
}
export function TesterPanelProvider({ children }) {
    const { api, user } = useAuth();
    const [session, setSession] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isMinimized, setIsMinimized] = useState(() => {
        try {
            return sessionStorage.getItem(MINIMIZED_KEY) === '1';
        }
        catch {
            return false;
        }
    });
    const setMinimized = useCallback((value) => {
        setIsMinimized(value);
        try {
            sessionStorage.setItem(MINIMIZED_KEY, value ? '1' : '0');
        }
        catch {
            // ignore
        }
    }, []);
    const refreshSession = useCallback(async () => {
        if (!user) {
            setSession(null);
            return;
        }
        setIsLoading(true);
        try {
            const result = await api.getTesterSession();
            setSession(result);
        }
        catch {
            setSession(null);
        }
        finally {
            setIsLoading(false);
        }
    }, [api, user]);
    useEffect(() => {
        void refreshSession();
    }, [refreshSession]);
    const value = useMemo(() => ({
        session,
        isLoading,
        isMinimized,
        setMinimized,
        refreshSession,
    }), [session, isLoading, isMinimized, setMinimized, refreshSession]);
    return _jsx(TesterPanelContext.Provider, { value: value, children: children });
}
//# sourceMappingURL=TesterPanelProvider.js.map